export interface AuthUser {
  user_id: number;
  name: string;
  role: string;
  username?: string;
  roles?: string[];
}

type AuthListener = (user: AuthUser | null) => void;

export const LEGACY_AUTH_STORAGE_KEYS = [
  'tuanzhang_user',
  'tuanzhang_user_id',
  'tuanzhang_admin_id',
  'tuanzhang_role',
  'tuanzhang_logged_in',
] as const;

let currentUser: AuthUser | null = null;
const listeners = new Set<AuthListener>();

function notify(): void {
  listeners.forEach((listener) => listener(currentUser));
}

function getStorage(kind: 'localStorage' | 'sessionStorage'): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window[kind];
  } catch {
    return null;
  }
}

export function getCurrentUserSnapshot(): AuthUser | null {
  return currentUser;
}

export function setCurrentUserSnapshot(user: AuthUser | null): void {
  currentUser = user;
  notify();
}

export function clearCurrentUserSnapshot(): void {
  setCurrentUserSnapshot(null);
}

export function subscribeCurrentUser(listener: AuthListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function clearLegacyAuthStorage(): void {
  (['localStorage', 'sessionStorage'] as const).forEach((kind) => {
    const storage = getStorage(kind);
    if (!storage) return;
    LEGACY_AUTH_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
  });
}

export function clearLegacyAuthState(): void {
  clearLegacyAuthStorage();
  clearCurrentUserSnapshot();
}
